<div class="card">
    <app-table-with-filters></app-table-with-filters>
</div>